module.exports = __webpack_public_path__ + "static/EPD-logo_eng_mobile-673cbee26a145dfbdd72d61fdd27df63.jpg";